// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"585":"MainLayout","756":"AuthLayout"}[chunkId] || chunkId) + "-legacy." + {"169":"e86b49a1","320":"eedaa288","358":"7845c672","585":"89ef3dbb","727":"1d6bbb16","756":"8539d643","773":"35011013","975":"ccc3531d"}[chunkId] + ".js";
};